module.exports = __webpack_public_path__ + "static/img/20.db853287.png";